module.exports = __webpack_public_path__ + "img/connectvideo.d256f455.svg";